<template lang="pug">
  span
    .no-js-warning {{t('errors.messages.no-js')}}
    div.notifications(v-if="show_alert")
      div.alert.notification
        .row
          .columns.large-24
            p.registration-closed
              span(v-if="!['open', 'full'].includes(this.state.current_reg.program.render_registration_state)") {{t('app.program.registration_for_the_program_is_currently_closed')}}
              span(v-else) {{ t('app.program.no_active_sections_on_this_program') }}

    .row.sub-navigation
      .columns.large-24
        nav.breadcrumbs.left
          router-link(to="/family/dashboard") {{t('app.navigation.dashboard')}}
          router-link(v-if="reg_loaded")(:to="`${get_locale()}/organization/${state.current_reg.program.organization.slug}`") {{state.current_reg.program.organization.name}}
          router-link(v-if="reg_loaded")(:to="`${get_locale()}/organization/${state.current_reg.program.organization.slug}`") {{t('app.navigation.programs')}}
          span(v-if="reg_loaded") {{state.current_reg.program.name}}

    Loader(v-if="!reg_loaded")

    template(v-if="state.current_reg.state === 'draft' && reg_loaded")
      program_blocks(:send_program="state.current_reg.program" :preview="false" :edit_reg="true" @register_now="register_now")

    div(id="register-form" v-if="reg_loaded" ref="register-form")
      template(v-if="no_user || wrong_org")
        template(v-if="!(no_user && !state.current_reg.program.can_register())")
          .row
            .columns.large-24
              article.content-block
                header
                  .title {{t('app.titles.sections')}}
                section.content.clearfix
                  .columns.large-12.program-section-item(v-for="section in active_sections")
                    .container
                      strong {{section.name + ' - '}}
                      | {{ duration(section.starts_at, section.ends_at) }}
                    .meeting-time(v-if="section.meeting_times") {{section.meeting_times}}

        template(v-if="no_user")
          .row.can-register(v-if="state.current_reg.program.can_register()")
            .columns.large-12
              .center
                router-link(:to="{path: '/signup', query:{direct_program_signup: true, return_to: $route.path}}" class="button large expand") {{t('app.programs.sign_up_to_register')}}
                div {{t('app.programs.sign_up_explanation')}}
            .columns.large-12
              .center
                router-link(:to="{path: '/login', query:{return_to: $route.path}}" class="button large expand") {{t('app.programs.sign_in_to_register')}}
                div {{t('app.programs.sign_in_explanation')}}
          .row(v-else)
            .columns.large-24
              .center
                p(style="color:#b61e11;display: block; margin-top: 0px; margin-bottom: 1.25rem;")
                  | {{t('app.notifications.online_registration_for_this_program_is_currently_closed_unavailable', {organization_name: state.current_reg.program.organization.name})}}

        template(v-else-if="wrong_org") //This happens if you will use org side link from an another org example- /organizations/{other_org_id}/programs/{program_name}
          .row
            .columns.large-24
              .flash-message.error(style="margin-top:0" data-alert="" data-nohide="")
                | {{t('app.programs.you_have_to_change_role_to_family_account')}}
      template(v-else)
        div.edit_registration(v-if="(state.current_reg.program.can_register() && active_sections.length > 0) || (current_org && current_org.id === state.current_reg.program.organization_id)" )
          edit_form(:reg_loaded="reg_loaded" :all_loaded="all_loaded" :people="people" @reload="reload")
        .row(v-else)
          .columns.large-24
            .center
              p(style="color:#b61e11;display: block; margin-top: 0px; margin-bottom: 1.25rem;")
                | {{t('app.notifications.online_registration_for_this_program_is_currently_closed_unavailable', {organization_name: state.current_reg.program.organization.name})}}
    .row(v-if="locale && locale !== 'en' && reg_loaded && state.current_reg.program.organization.allow_google_translate_date")
      .columns.large-24
        .gt-disclaimer {{t('app.account.languages.gt_disclaimer')}}
</template>

<script>
import program_blocks from "../programs/_show.vue";
import registration_loader_helper from '../registrations/registration_loader_helper'
import edit_form from '../registrations/edit_form'
import Modal from 'templates/shared/_modal'
import Loader from '../shared/_loader'
import reg_helper from "../registrations/helper.js"


export default {
  name: "RegistrationEdit",
  components: { edit_form, program_blocks,Modal,Loader},
  mixins: [registration_loader_helper, reg_helper],
  data() {
    return {
      reg_loaded: false,
      all_loaded: false,
      people: [],
      modal:{show: false}
    }
  },
  created() {
    // preset org id to load everything as organization
    if (this.$route.params.organization_id){
      this.state.current_org.id = this.$route.params.organization_id
    }
    this.load_on_created()
  },
  methods: {
    register_now(){
      console.log('register_now')
      console.log(this.$refs['register-form'])
      const element = this.$refs['register-form'];
      element.scrollIntoView({ behavior: 'smooth' });
    },

    partComponent(part){
      return this.$options.components["PartHeader"+part.style] ? "PartHeader"+part.style : "PartHeader"
    },
  },
  computed:{
    wrong_org(){
      return this.state.current_org.id && this.state.current_reg.program.organization_id !== this.state.current_org.id
    },
    no_user(){
      return !this.state.current_user.id
    },
    locale(){
      return window.locale
    },
    active_sections(){
      return this.state.current_reg.program.sections.filter(s => s.valid_today() && !s.keep_hidden)
    },
    show_alert(){
      if(!this.reg_loaded){return false}
      return (!['open', 'full'].includes(this.state.current_reg.program.render_registration_state) || !(this.active_sections.length > 0))
    },
    that(){
      return this
    },
  },
  destroyed(){
    this.$store.commit('unloadReg')
  }
}
</script>
<style scoped>
.preview{
  padding-bottom: 0 !important;
}
input[aria-invalid="true"] {
  border-color: #b61e11;
}
</style>

<style lang="scss">
$color-red: #b61e11;

.edit_registration{
  label.error, .int-tel-input-wapper.error {
    input, textarea, .select{
      border-color: $color-red;
      background-color: rgba($color-red, 0.2) !important;
    }
  }
  .ant-upload-drag-input.error{
    .ant-upload-drag{
      background-color: rgba($color-red, 0.2) !important;
    }
  }
}
</style>
